import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { set_current_workspace, try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { useNavigate, useParams } from 'react-router-dom';

export function WatcherSlugPageDiffusionModels() {
  const navigate = useNavigate();
  const { workspace_id: workspace_id_from_slug } = useParams();

  const { auth_token } = use_slice_user(['auth_token']);
  const { is_all_data_loaded, workspace_current, workspaces_map } = use_slice_workspace(['is_all_data_loaded', 'workspace_current', 'workspaces_map']);

  /*
   * EFFECTS
   */
  use_effect(() => void set_workspace_from_slug(), [is_all_data_loaded, auth_token]);

  use_effect(() => {
    if (!is_all_data_loaded) return;

    //could be stub when from user deleted permissions to view entities
    let workspace_id = workspace_current.is_stub() ? '' : workspace_current._id;

    //sync slug with redux
    void navigate(ENUM__page_type.BUILD_PATH_DIFFUSION_MODELS(workspace_id), { replace: true });
  }, [is_all_data_loaded, workspace_current]);

  /*
   * METHODS
   */

  async function set_workspace_from_slug() {
    if (!auth_token) return; //not authorized
    if (!is_all_data_loaded) return; // not all data loaded

    //already equal
    if (workspace_current._id === workspace_id_from_slug && !workspace_current.is_stub()) return set_current_workspace(workspace_id_from_slug);

    if (!workspace_current.is_stub()) return; //already established

    let entity_from_slug = [...workspaces_map.values()].find(item => item._id == workspace_id_from_slug);

    if (entity_from_slug) {
      set_current_workspace(entity_from_slug._id);
    } else if (workspace_current.is_stub()) {
      await try_set_default_workspace();
    }
  }

  return <></>;
}
